// extracted by mini-css-extract-plugin
export var popular = "CategoryCardSection-module--popular--1jc13";
export var popularCards = "CategoryCardSection-module--popularCards--3aM9Y";